import "core-js/modules/es.array.push.js";
export default {
  data() {
    return {
      date: '',
      classify1: '',
      classifyList: [],
      cataloguePermalink: '',
      author: null,
      categories: []
    };
  },
  created() {
    this.getPageInfo();
  },
  watch: {
    '$route.path'() {
      this.classifyList = [];
      this.getPageInfo();
    }
  },
  methods: {
    getPageInfo() {
      const pageInfo = this.$page;
      const {
        relativePath
      } = pageInfo;
      const {
        sidebar
      } = this.$themeConfig;

      // 分类采用解析文件夹地址名称的方式 (即使关闭分类功能也可以正确跳转目录页)
      const relativePathArr = relativePath.split('/');

      // const classifyArr = relativePathArr[0].split('.')

      relativePathArr.forEach((item, index) => {
        const nameArr = item.split('.');
        if (index !== relativePathArr.length - 1) {
          if (nameArr === 1) {
            this.classifyList.push(nameArr[0]);
          } else {
            const firstDotIndex = item.indexOf('.');
            this.classifyList.push(item.substring(firstDotIndex + 1) || '');
          }
        }
      });
      this.classify1 = this.classifyList[0];
      const cataloguePermalink = sidebar && sidebar.catalogue ? sidebar.catalogue[this.classify1] : ''; // 目录页永久链接
      const author = this.$frontmatter.author || this.$themeConfig.author; // 作者
      let date = (pageInfo.frontmatter.date || '').split(' ')[0]; // 文章创建时间

      // 获取页面frontmatter的分类（碎片化文章使用）
      const {
        categories
      } = this.$frontmatter;
      this.date = date;
      this.cataloguePermalink = cataloguePermalink;
      this.author = author;
      this.categories = categories;
    },
    getLink(item) {
      const {
        cataloguePermalink
      } = this;
      if (item === cataloguePermalink) {
        return cataloguePermalink;
      }
      return `${cataloguePermalink}${cataloguePermalink.charAt(cataloguePermalink.length - 1) === '/' ? '' : '/'}#${item}`;
    }
  }
};